interface BranchInfo {
  id: string
  coachingCenterId: string
  branchName: string
  address1: string
  address2: string
  country: string
  state: string
  city: string
  zipCode: string
  mobileNumber: string
  email: string
  isMainBranch: string
  questionLimit: string
  status: 'ACTIVE' | ''
}

export interface CourseInfo {
  id: string
  courseName: string
  parentId: string
  parentName: string
  description: string
  status: 'ACTIVE' | ''
}

export interface BatchInfo {
  id: string
  coachingCenterId: string
  batchName: string
  additionalCourseId: string
  courseId: string
  course: CourseInfo
  batchSize: string
  description: string
  status: 'ACTIVE' | ''
}

interface CoachingCenterInfo {
  id: string
  coachingCentreName: string
  mobileNumber: string
  address1: string
  address2: string
  country: string
  state: string
  city: string
  zipCode: string
  expiryOn: string
  status: 'ACTIVE' | ''
  coachingCenterCode: string
  questionLimit: string
  logoUrl: string
}

export interface UserInfo {
  role: string
  userDetail: {
    userDetailId: string
    usersId: string
    status: string
    userName: string
    branchIds: Array<string>
    branchList: Array<BranchInfo>
    batchList: Array<BatchInfo>
    coachingCentre: CoachingCenterInfo
    coachingCenterId: string
    firstName: string
    studentAccess: boolean
    subject: string
  }
  token: string
}

export interface File {
  courseId: string
  createdAt: number
  createdBy: string
  entityType: string
  fileName: string
  filePath: string
  id: string
  noOfRecords: number
  status: string
  updatedAt: number
  updatedBy: string
  uploadedOn: string
}

export interface UploadFileResponse {
  fileList: Array<File> | null
  pageSize: number
  currentPage: number
}

interface StudentActivity {
  startDate?: Date | string
  toDate?: Date | string
  instituteId?: string
  branchId?: string
  batchId?: string
}

// Define a type for the slice state
interface UserState {
  isLoggedIn: boolean
  isLoading: boolean
  userName: string
  password: string
  device: string
  userInfo: UserInfo | null
  hasError?: boolean
  selectedBatch?: string
  selectedCourse?: string
  uploadedFiles: UploadFileResponse
  studentActivity: StudentActivity | any
  downloadFile: string
}

// Define the initial state using that type
export const initialState: UserState = {
  isLoggedIn: false,
  isLoading: false,
  userName: '',
  password: '',
  device: '',
  userInfo: null,
  hasError: false,
  selectedBatch: '',
  selectedCourse: '',
  uploadedFiles: {
    fileList: [],
    pageSize: 0,
    currentPage: 0
  },
  studentActivity: {
    startDate: new Date(),
    toDate: new Date(),
    instituteId: '',
    branchId: '',
    batchId: ''
  },
  downloadFile: ''
}

export interface UpdateActivityData {
  key: string
  value: string | Date
}

export interface AuthenticatePayload {
  loginDevice: 'mobile' | 'website'
}

export interface SaveBulkEntryPayload {
  instituteId: string
  branchId: string
  batchId: string
  file: any
}
